module.exports = __webpack_public_path__ + "img/sheet-metal-shack.2dde22e5.jpg";